// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2oUep","log":"ModalInventoryLogs_log__1pCXS","date":"ModalInventoryLogs_date__1hnZi","userName":"ModalInventoryLogs_userName__1ZTNS"};